import {createAsyncThunk} from '@reduxjs/toolkit';
import {getMonthlyRates} from 'api/rates/monthly/get-monthly-rates';
import updateMonthlyRate, {
    UpdateMonthlyRateParams,
} from 'api/rates/monthly/update-monthly-rate';

interface MonthlyRatesParams {
    facilityId: number;
}

/**
 * A Redux thunk for fetching monthly rates data.
 */
export const getMonthlyRatesData = createAsyncThunk(
    'monthlyRates/getMonthlyRatesData',
    async ({facilityId}: MonthlyRatesParams, {rejectWithValue, signal}) => {
        try {
            const response = await getMonthlyRates(facilityId, {
                signal,
            });

            return response;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

/**
 * A Redux thunk for updating a monthly rate.
 */
export const updateMonthlyRateData = createAsyncThunk(
    'monthlyRates/updateMonthlyRateData',
    async (data: UpdateMonthlyRateParams, {rejectWithValue}) => {
        try {
            const response = await updateMonthlyRate(data);

            return response;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);
